module.exports = __webpack_public_path__ + "static/media/integral_list_item_03.29c5ad21.png";